import type { Lang } from '../../../lib/i18n'
import type { OrderStatusHistoryEntry } from '../../../lib/orders-api'
import { Ltr } from '../Ltr'
import { formatDateTime } from '../format'
import { ot, STATUS_BADGE_LABEL } from '../orders-i18n'
import { SectionCard } from './SectionCard'

interface Props {
  history: OrderStatusHistoryEntry[]
  lang: Lang
}

export function ActivityTimeline({ history, lang }: Props) {
  return (
    <SectionCard title={ot(lang, 'activityTitle')} lang={lang}>
      {history.length === 0 ? (
        <p className="text-sm text-muted-foreground">{ot(lang, 'noActivity')}</p>
      ) : (
        <ol className="space-y-3">
          {[...history].reverse().map((entry) => (
            <li key={entry.id} className="flex items-start gap-3 text-sm">
              <div className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-navy" />
              <div className="min-w-0 flex-1">
                <div className="text-foreground">
                  {entry.fromStatus && (
                    <>
                      {ot(lang, 'from')} <span className="font-medium">{STATUS_BADGE_LABEL[entry.fromStatus][lang]}</span>{' '}
                      {ot(lang, 'to')}{' '}
                    </>
                  )}
                  <span className="font-medium">{STATUS_BADGE_LABEL[entry.toStatus][lang]}</span>
                </div>
                <div className="text-xs text-muted-foreground">
                  <Ltr>{formatDateTime(entry.changedAt)}</Ltr>
                  {' · '}
                  {entry.changedBy?.name || entry.changedBy?.email || ot(lang, 'changedBySystem')}
                </div>
                {entry.notes && <p className="mt-0.5 text-xs text-muted-foreground">{entry.notes}</p>}
              </div>
            </li>
          ))}
        </ol>
      )}
    </SectionCard>
  )
}
